jQuery(document).ready(function($) {

  var berryCount = 8; var berryImage = "url(https://cdn.shopify.com/s/files/1/0324/0640/5179/files/berries.jpg?v=1632926330)";
  var fishCount = 3; var fishImage = "url(https://cdn.shopify.com/s/files/1/0324/0640/5179/files/fish.jpg?v=1632926322)";
  var teaCount = 14; var teaImage = "url(https://cdn.shopify.com/s/files/1/0324/0640/5179/files/teas.jpg?v=1632926316)";
  var greenCount = 14; var greenImage = "url(https://cdn.shopify.com/s/files/1/0324/0640/5179/files/greens.jpg?v=1632926326)";
  var nutsCount = 12; var nutsImage = "url(https://cdn.shopify.com/s/files/1/0324/0640/5179/files/nuts.jpg?v=1632926319)";
  
  var berryValue = $( "select.berries option:checked" ).val();
    var percentage = (berryValue / berryCount) * 100;
    if(percentage > 100){ percentage = 100; }
    $('.berry-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + berryImage);
  	$('.berry-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
  	$('.berry-percentage').html(Math.round(percentage) + '%');
  var fishValue = $( "select.fish option:checked" ).val();
    var percentage = (fishValue / fishCount) * 100;
  	if(percentage > 100){ percentage = 100; }
    $('.fish-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + fishImage);
  	$('.fish-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
  	$('.fish-percentage').html(Math.round(percentage) + '%');
  var teaValue = $( "select.teas option:checked" ).val();
    var percentage = (teaValue / teaCount) * 100;
  	if(percentage > 100){ percentage = 100; }
    $('.tea-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + teaImage);
  	$('.tea-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
  	$('.tea-percentage').html(Math.round(percentage) + '%');
  var greenValue = $( "select.greens option:checked" ).val();
    var percentage = (greenValue / greenCount) * 100;
  	if(percentage > 100){ percentage = 100; }
    $('.green-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + greenImage);
  	$('.green-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
  	$('.green-percentage').html(Math.round(percentage) + '%');
  var nutsValue = $( "select.nuts option:checked" ).val();
    var percentage = (nutsValue / nutsCount) * 100;
  	if(percentage > 100){ percentage = 100; }
    $('.nuts-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + nutsImage);
  	$('.nuts-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
  	$('.nuts-percentage').html(Math.round(percentage) + '%');
  
  $('.berries').change(function() {
    var berryValue = $( "select.berries option:checked" ).val();
    var percentage = (berryValue / berryCount) * 100;
    if(percentage > 100){ percentage = 100; }
    $('.berry-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + berryImage);
  	$('.berry-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
    $('.berry-percentage').html(Math.round(percentage) + '%');
  });
  
  $('.fish').change(function() {
    var fishValue = $( "select.fish option:checked" ).val();
    var percentage = (fishValue / fishCount) * 100;
    if(percentage > 100){ percentage = 100; }
    $('.fish-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + fishImage);
  	$('.fish-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
    $('.fish-percentage').html(Math.round(percentage) + '%');
  });
  
  $('.teas').change(function() {
    var teaValue = $( "select.teas option:checked" ).val();
    var percentage = (teaValue / teaCount) * 100;
    if(percentage > 100){ percentage = 100; }
    $('.tea-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + teaImage);
  	$('.tea-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
    $('.tea-percentage').html(Math.round(percentage) + '%');
  });
  
  $('.greens').change(function() {
    var greenValue = $( "select.greens option:checked" ).val();
    var percentage = (greenValue / greenCount) * 100;
    if(percentage > 100){ percentage = 100; }
    $('.green-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + greenImage);
  	$('.green-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
    $('.green-percentage').html(Math.round(percentage) + '%');
  });
  
  $('.nuts').change(function() {
    var nutsValue = $( "select.nuts option:checked" ).val();
    var percentage = (nutsValue / nutsCount) * 100;
    if(percentage > 100){ percentage = 100; }
    $('.nuts-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + nutsImage);
  	$('.nuts-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
    $('.nuts-percentage').html(Math.round(percentage) + '%');
  });

  // for opening #supplement-facts
  $('a[href^="#"]').on('click', function (event) {
    var href = $(this).attr('href');

    if (!href || href === '#' || href.length < 2 || href.startsWith('#http')) {
      return;
    }

    var id = href.substring(1);
    var targetEl = document.getElementById(id);

    if (targetEl && targetEl.classList.contains('target_popup')) {
      event.preventDefault();

      Alpine.mutateDom(() => {
        const alpineComponent = Alpine.$data(targetEl);
        if (alpineComponent && typeof alpineComponent.show !== 'undefined') {
          alpineComponent.show = true;
        }
      });
    }
  });

  const tabs = document.querySelectorAll('.product-info .collapsible-tab');
  if (tabs.length) {
    tabs[tabs.length - 1].classList.add('last-collapsible-tab');
  }

  /* Add To Cart Submit */   

  $('.nr-addtocart-link').on('click', function(e) {

    if($(".update-product-id")){
      if($(this).data("id")){
        const product_id = $(this).data("id");

        $(".update-product-id").val(product_id);
        
      }
    }

    if($("#relevate-update-selling-plan")){
      if($(this).data("selling-plan")){
        const selling_plan_id = $(this).data("selling-plan");

        $("#relevate-update-selling-plan").val(selling_plan_id);
        
      } else {
        $("#relevate-update-selling-plan").val("");
      }
    }

  });

}); 

/* Updating Sticky ATC Section */

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.purchase-options-form');
  if(form) {
    let title = "";
    let price = "";
    let discount = "";

    const radios = form.querySelectorAll('input[name="purchase_option"]');
    const inicial = form.querySelector('#inicial_option')
    const variantInput = form.querySelector('input[name="id"]');
    const planInput = form.querySelector('input[name="selling_plan"]');

    let stickyValue = ""
    let stickyPlan = ""
    let stickyPrice = ""
    let stickyTitle = ""
    let section_id = ""

    const product_id = document.querySelector('input[name="product-id"]');

    //setting inicial values

    if(product_id.value == 4617290186811){
      title = "RELEVATE Monthly Delivery";
      price = "$87.49";
      discount = "$69.99";
    }
    else if(product_id.value == 9133071237349){
      title = "BHK EVOO 1 Canister";
      price = "";
      discount = "$44.39";
    } else if(product_id.value == 8379486929125){
      title = "RELEVATE - Two (2) Jars for Subscription";
      price = "$174.98";
      discount = "$135.99";
    } 
    else if(product_id.value == 9382597787877){
      title = "REVANTA Creatine Monthly Delivery";
      price = "$39.99"; //original price
      discount = "$35.99"; //sale price
    } else if(product_id.value == 9450090430693) {
      title = "REVANTA Creatine Buy One Time";
      discount = "$39.99";
    } else if(product_id.value == 9477603983589) {
      title = "RELEVATE Buy 2-Month Supply";
      price = "$174.98"; //original price
      discount = "$104.99"; //discount price
    } 
    else if (inicial) {
      title = inicial.dataset.name;
      price = inicial.dataset.ogprice;
      discount = inicial.dataset.newprice;
    } else {
      return;
    }

    const sticky_elm = document.querySelector('[data-sticky-section-id]');
    
    if(sticky_elm){
      section_id = sticky_elm.dataset.stickySectionId;
    };
    if(section_id){
      stickyValue = document.getElementById('update-variant-sticky-'+section_id);
      stickyPlan = document.getElementById('update-selling-plan-sticky-'+section_id);
      stickyPrice = document.getElementById('price-sticky-'+section_id);
      stickyTitle = document.getElementById('title-sticky-'+section_id);
      
      stickyValue.value = variantInput.value;
      if(planInput) {
        stickyPlan.value = planInput.value
      }
      stickyPrice.innerHTML = "<span class='price'><b>"+discount+"</b> <s>"+price+"</s></span>";
      stickyTitle.innerHTML = title;
    }

    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        if(sticky_elm){
          section_id = sticky_elm.dataset.stickySectionId;
        };
        if(section_id){
          stickyValue = document.getElementById('update-variant-sticky-'+section_id);
          stickyPlan = document.getElementById('update-selling-plan-sticky-'+section_id);
          stickyPrice = document.getElementById('price-sticky-'+section_id);
          stickyTitle = document.getElementById('title-sticky-'+section_id);
        }
        variantInput.value = radio.dataset.id;
        if(planInput) {
          planInput.value = radio.dataset.selling_plan;
          console.log(radio.dataset.selling_plan);
        } else {
          console.log(radio.dataset.selling_plan);
        }
        if(radio.value == 'once'){
          title="RELEVATE Buy One Time"
          price=""
          discount = "$87.49"
        }
        else if(radio.value == 'monthly'){
          title="RELEVATE Monthly Delivery"
          price="$87.49"
          discount = "$69.99"
        }
        else if(radio.value == 'three_month'){
          title = "RELEVATE Three Month Delivery";
          price = "$262.47";
          discount = "$195.99";
        }
        else if(radio.value == 'six_month'){
          title = "RELEVATE Six Month Delivery";
          price = "$524.94";
          discount = "$377.99";
        }
        else if(radio.value == 'one_canister'){
          title = "BHK EVOO 1 Canister";
          price = "";
          discount = "$44.39";
        }
        else if(radio.value == 'two_canister'){
          title = "BHK EVOO 2 Canisters";
          price = "$88.78";
          discount = "$85.29";
        }
        else if(radio.value == 'three_canister'){
          title = "BHK EVOO 3 Canisters";
          price = "$133.17";
          discount = "$122.59";
        }
        else if(radio.value == 'once_revanta'){
          title = "REVANTA Creatine Buy One Time";
          price = "";
          discount = "$39.99"; //original price
        }
        else if(radio.value == 'bimonthly_revanta'){
          title = "REVANTA Creatine Delivery Every 2 Months";
          price = "$39.99"; //original price
          discount = "$35.99"; //sale price
        }
        else if(radio.value == 'monthly_revanta'){
          title = "REVANTA Creatine Monthly Delivery";
          price = "$39.99"; //original price
          discount = "$35.99"; //sale price
        }
        else if(radio.value == 'once_revanta_promo'){
          title = "REVANTA Creatine Buy One Time";
          price = "";
          discount = "$39.99"; //original price
        } else if(radio.value == 'two_revanta'){
          title = "REVANTA Creatine Buy 2 Pouches";
          price = "$79.98"; //original price
          discount = "$63.98"; //coupon price
        } else if(radio.value == 'onem_supply_relevate'){
          title = "RELEVATE Buy 1-Month Supply";
          price = "";
          discount = "$87.49"; //original price
        } else if(radio.value == 'twom_supply_relevate'){
          title = "RELEVATE Buy 2-Month Supply";
          price = "$174.98"; //original price
          discount = "$104.99"; //discount price
        }
        else {
          title = radio.dataset.name;
          price = radio.dataset.ogprice;
          discount = radio.dataset.newprice;
        }

        if(stickyValue){
          stickyValue.value = radio.dataset.id;
        }
        if(stickyPlan){
          stickyPlan.value = radio.dataset.selling_plan || '';
        }
        if(stickyPrice){
          stickyPrice.innerHTML = "<span class='price'><b>"+discount+"</b> <s>"+price+"</s></span>";
        }
        if(stickyTitle){
          stickyTitle.innerHTML = title;
        }
      });
    });
  }

});